<ngx-loading-bar class="spinner" [includeSpinner]="false" [includeBar]="true"></ngx-loading-bar>
<smart-header (showSendMessage)="sendMessageModalActions.emit({ action: 'modal', params: ['open'] })"></smart-header>
<main>
  <app-page-h1></app-page-h1>
  <router-outlet></router-outlet>
</main>
<smart-footer></smart-footer>
<div 
  id="send-message-modal" 
  class="modal card" 
  srModal 
  [dismissible]="true"
  [materializeActions]="sendMessageModalActions"
>
  <send-message [modalActions]="sendMessageModalActions"></send-message>
</div>
